/** Zoom limits every Google map in the workspace stops at on + / − (buttons, wheel, pinch, fitBounds). */
export const MAP_ZOOM_LIMITS = {
  minZoom: 3,
  maxZoom: 18,
} as const satisfies Pick<google.maps.MapOptions, 'minZoom' | 'maxZoom'>;
